import { useCallback, useState, useEffect } from "react"
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap"
import BreadCrumb from "../../Components/BreadCrumb"
import SummaryILNP from "./components/SummaryPrestaking"
import StakingILNP from "./pools/NodePrestaking"

import { formatNumber, formatAmount } from "../../utils"
import { api } from "../../apis/staking/api"
import ilnpAbi from "../../abi/NodePrestaking.json"
import fidoAbi from "../../abi/FIDO.json"
import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"

const Prestaking = ({ location }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [stakedAmount, setStakedAmount] = useState(395000)
    const [stakedByPools, setStakedByPools] = useState({ sob: 0 })
    const [numNodes, setNumNodes] = useState(11)
    const [igspApy, setIgspApy] = useState(0)
    const [lastReward, setLastReward] = useState(300000)
    const pools = {
        ilnp: {
            providerUri: "https://mainnet.era.zksync.io",
            explorer: "https://explorer.zksync.io/",
            chainSymbol: "ZKSYNC",
            poolSymbol: "ILNP",
            poolName: "Idexo L3 Node Prestaking",
            breadCrumb: "Idexo L3 Node Prestaking",
            apy: "N/A",
            next_deadline: "N/A",
            chainId: 324,
            args: { maxPriorityFeePerGas: 250000000 },
            stakingContractAddress: "0x770742ceCc41Ab0bB996943E951E79039b798dD1",
            stakingAbi: ilnpAbi,
            timeLock: false,
            flexLock: false,
            multRewards: false,
            rewardTokens: [
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi },
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi }
            ],
            tokenContractAddress: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C",
            tokenSymbol: "IDO",
            tokenAbi: fidoAbi
        }
    }
    const [active, setActive] = useState("")
    const [price, setPrice] = useState(0)
    const [circSupply, setCircSupply] = useState(0)
    const wallet = useWallet()

    useEffect(() => {
        ;(async () => {
            if (updateConnection() && wallet.account) {
                setIsLoading(true)
                try {
                    let provider = new Web3("https://mainnet.era.zksync.io")

                    let stakingContract = new provider.eth.Contract(ilnpAbi, "0x770742ceCc41Ab0bB996943E951E79039b798dD1")

                    let balance = await stakingContract.methods.totalSupply().call()
                    setNumNodes(balance)
                } catch (err) {
                    console.log(err)
                }
                setIsLoading(false)
            }
        })()
    }, [wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    // const getCircSupply = async () => {
    //     const data = await api.getCircSupply()
    //     if (data) {
    //         setCircSupply(data)
    //     }
    // }
    // const getPrice = async () => {
    //     const data = await api.getPrice()
    //     if (data) {
    //         setPrice(data["idexo-token"]["usd"])
    //         const usdprice = data["idexo-token"]["usd"]
    //         const apycalc = parseInt(((lastReward * 12) / stakedByPools.igspv2) * 100)
    //         setIgspApy(apycalc)
    //     }
    // }

    const handleStakedAmount = (symbol, staked) => {
        const pool = symbol.toLowerCase()
        stakedByPools[pool] = staked
        setStakedByPools({ ...stakedByPools })
    }

    useEffect(() => {
        if (wallet.connected) {
            let total = 0
            for (const pool of Object.keys(stakedByPools)) {
                total += parseInt(stakedByPools[pool])
            }
            setStakedAmount(total)
        }
    }, [stakedByPools])

    // useEffect(() => {
    //     try {
    //         getCircSupply()
    //         getPrice()
    //     } catch (error) {
    //         console.log(error)
    //     }
    //     return () => {
    //         // clean
    //     }
    // }, [])

    const handleExpanded = useCallback(
        (poolId) => {
            if (poolId === active) {
                setActive("")
            } else {
                setActive(poolId)
            }
        },
        [active]
    )
    const pool = new URLSearchParams(location.search).get("pool")?.toLowerCase()

    switch (pool) {
        case "ilnp":
            return <StakingILNP pool={pools[pool]} />
        // case "igspv2":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "ibbp":
        //     return <Staking pool={pools[pool]} />
        // case "isip":
        //     return <Staking pool={pools[pool]} />
        // case "itip":
        //     return <Staking pool={pools[pool]} />
        // case "nftme":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "igspvz":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "ghd":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "dragon":
        //     return <StakingFlexLock pool={pools[pool]} />
        default:
            break
    }

    const marketCap = () => {
        let mc = 0

        if (price && circSupply) {
            mc = parseInt(price * circSupply)
            mc = formatAmount(mc, 2)
        }

        return mc
    }

    return (
        <div className="content stake-page">
            <BreadCrumb items={["Staking Dashboard"]} />
            <div className="stake-body">
                <Card>
                    <CardHeader>
                        <CardTitle className="h3">Idexo L3 Node Pre-Staking</CardTitle>
                    </CardHeader>
                    <CardBody className="dashboard pt-0">
                        <div className="staked-info">
                            <div>
                                <div className="title">Total Staked</div>
                                <div className="value">{formatNumber(stakedAmount.toFixed(0))} IDO</div>
                            </div>

                            <div>
                                <div className="title"># of Nodes</div>
                                <div className="value">{numNodes}</div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <div className="pools-body">
                            <div className="pools-header">
                                <div>Symbol</div>
                                <div>Name</div>
                                <div>Your Nodes</div>
                                <div>Current Price</div>
                            </div>
                            <SummaryILNP
                                pool={pools.ilnp}
                                active={active}
                                onExpand={handleExpanded}
                                handleStakedAmount={handleStakedAmount}
                            ></SummaryILNP>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default Prestaking
